import {BaseConstants} from "../constants/BaseConstants";

// Lifted out of the reducer body - this used to be rebuilt on every dispatched action.
const cachedValues = new Map([
    [BaseConstants.SCHEDULES, "schedules"], [BaseConstants.PRESCRIPTIONS, "prescriptions"],
    [BaseConstants.PARAMETERS, "parameterMap"], [BaseConstants.NATIONALITIES, "lookupNationalities"],
    [BaseConstants.COUNTRIES, "lookupCountries"], [BaseConstants.LANGUAGES, "lookupLanguages"],
    [BaseConstants.RELIGIONS, "lookupReligions"], [BaseConstants.MARITAL_STATUS, "lookupMaritalStatuses"],
    [BaseConstants.RELATIONSHIP_TYPES, "relationshipTypes"], [BaseConstants.ALLERGY_TYPES, "allergyTypes"],
    [BaseConstants.ALLERGEN_TYPES, "allergenTypes"], [BaseConstants.ALLERGEN_REACTION_TYPES, "allergenReactionTypes"],
    [BaseConstants.ALLERGY_SEVERITIES, "allergySeverities"], [BaseConstants.LOOKUP_GENDERS, "lookupGenders"],
    [BaseConstants.EMPLOYMENT_STATUSES, "employmentStatuses"], [BaseConstants.EDUCATION_LEVELS, "educationLevels"],
    [BaseConstants.SMOKING_DEVICES, "smokingDevices"], [BaseConstants.SMOKING_STATUSES, "smokingStatuses"],
    [BaseConstants.DRINKING_STATUSES, "drinkingStatuses"], [BaseConstants.SUBSTANCE_ABUSE_STATUSES, "substanceAbuseStatuses"],
    [BaseConstants.MEDICATION_ROUTES, "medicationRoutes"], [BaseConstants.MEDICATION_UNITS, "medicationUnits"],
    [BaseConstants.EXERCISE_ACTIVITIES, "exerciseActivities"]
]);

// Cached collections start out empty so consumers always receive an array, even on the
// first render before any lookup has been restored from cache or fetched. The lookup
// actions no longer blank the store before refetching, so this is the only seed.
const initialState = Array.from(cachedValues.values()).reduce((state, stateKey) => {
    state[stateKey] = stateKey === "parameterMap" ? {} : [];
    return state;
}, {baseUrl: "", remotingOperationCount: 0});

export function base(state = initialState, action) {

    if (action.type === 'INCREMENT_REMOTING_OPERATION_COUNT') {
        let newState = {...state};
        newState["remotingOperationCount"] = newState["remotingOperationCount"] + 1;
        return newState;
    } else if (action.type === 'DECREMENT_REMOTING_OPERATION_COUNT') {
        let newState = {...state};
        newState["remotingOperationCount"] = newState["remotingOperationCount"] - 1;
        if (newState["remotingOperationCount"] < 0) {
            newState["remotingOperationCount"] = 0;
        }
        return newState;
    } else if (action.type === 'SET_VALUE') {
        let newState = {...state};
        newState[action.key] = action.value;
        return newState;
    } else { // cached values
        const cachedValueLabel = cachedValues.get(action.type);
        if (cachedValueLabel) {
            let newState = {...state};
            newState[cachedValueLabel] = action.value;
            return newState;
        }
    }

    return state;
}
